import { forwardRef, memo, type ReactNode, type Component } from 'react';
// Material UI imports
import Box, { type BoxProps } from '@mui/material/Box';
// SCSS imports
import { scrollable, autofitScrollable } from './Scrollable.module.scss';

type ScrollableProps = {
  readonly autofit?: boolean;
  readonly children: ReactNode;
  readonly sx?: BoxProps['sx'];
};

const Scrollable = forwardRef<Component<BoxProps>, ScrollableProps>(({
  autofit = false,
  children,
  sx
}, ref) => (
  <Box
      ref={ref}
      sx={sx}
      color="text.primary"
      pr={2}
      className={autofit ? autofitScrollable : scrollable}
  >
    {children}
  </Box>
));

Scrollable.displayName = 'Scrollable';

export default memo(Scrollable);
